import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Topmenuleft() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAddOnServicesClick = (event) => {
    event.preventDefault();

    const scrollToSection = () => {
      document
        .getElementById('addon-services-section')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (location.pathname === '/' || location.pathname === '/home') {
      scrollToSection();
      return;
    }

    navigate('/home#addon-services-section');
    setTimeout(scrollToSection, 150);
  };

  const handleAboutLocationBanner = (event) => {
    event.preventDefault();

    const scrollToSection = () => {
      document
        .getElementById('about-location-banner')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    if (location.pathname === '/' || location.pathname === '/home') {
      scrollToSection();
      return;
    }

    navigate('/home#about-location-banner');
    setTimeout(scrollToSection, 150);
  };

  return (
    <nav class="navbar navbar-expand-lg">       

        <div class="1collapse 1navbar-collapse" id="navbarExampleOnHover">

          <ul class="navbar-nav">
            <li class="nav-item first">
               <Link className='nav-link' to='/home'>Home</Link>
            </li>

            <li class="nav-item">
               <Link className='nav-link' to='/home#about-location-banner' onClick={handleAboutLocationBanner}>Sets</Link>
            </li>        
            
            <li class="nav-item">
               <Link className='nav-link' to='/home#addon-services-section' onClick={handleAddOnServicesClick}>Add On Services</Link>
            </li>

             <li class="nav-item">
               <Link className='nav-link' to='#'> Book Now</Link>
            </li>

              <li class="nav-item">
               <Link className='nav-link' to='#'>About Us</Link>
            </li>

             <li class="nav-item">
               <Link className='nav-link' to='/contact'>Contact us</Link>
            </li>

         

          </ul>

        </div>

    
     

    </nav>
  )

}

export default Topmenuleft;
